import React from 'react';
import "./Insta.css";
import instaLogo from "../../images/instagram.webp";

function Insta() {

  return (
    <div className='Insta'>
      <a href='https://www.instagram.com/thefacebyanahit' aria-label='TheFaceByAnahit instagram page' target='_blank' rel="noreferrer"><img className='InstaLogo' src={instaLogo} alt="instagram icon"/></a>
    </div>
  )
}

export default Insta